import script from "./employee-org-chart.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-org-chart.vue?vue&type=script&setup=true&lang=js"

import "./employee-org-chart.vue?vue&type=style&index=0&id=42141f74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42141f74"]])

export default __exports__